import { Button, Card } from "@blueprintjs/core";
import { Result } from "@zxing/library";
import { useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { FlexContainer } from "../../../components/flex/Flex";
import { parse_rjson } from "../../../utils/rjson";

const parse_json = (obj: any) => JSON.stringify(obj);

/*
  Z42529953\x1D
  1PIRLR8743PBF\x1D
  Q25\x1D
  1VINFI\x1D
  30T0000930305\x1D
  31T\x1D
  6D20180618\x1D
  30PY\x1D
  Z1\x1E\x04
*/

const asc_mh10_header = "[)>\x1E06\x1D";
const asc_mh10_close = "\x1E\x04";
const asc_mh10_group_sep = "\x1D";
const parse_asc_mh10 = (text: string) => {
  let data = text.substring(
    asc_mh10_header.length,
    text.length - asc_mh10_close.length
  );

  const groups = data.split(asc_mh10_group_sep);
  console.log("got groups", groups);

  let obj = {};

  return obj;
};

const parse = (result: Result) => {
  const text = result.getText();

  console.log("parsing", text);

  console.log("json?");

  try {
    const json_data = JSON.parse(text);
    return parse_json(json_data);
  } catch (e) {
    console.log("not json", e);
  }

  let rjson = parse_rjson(text);
  if (rjson !== null) {
    return rjson;
  } else {
    console.log("not rson");
  }

  if (text.startsWith(asc_mh10_header)) return parse_asc_mh10(text);

  return false;
};

export const ScanView = (props: any) => {
  const [streamEnabled, setStreamEnabled] = useState(true);
  const [content, setContent] = useState<any>({});

  return (
    <FlexContainer>
      <Card elevation={3}>
        <Button
          icon={streamEnabled ? "stop" : "play"}
          intent={streamEnabled ? "danger" : "success"}
          onClick={() => setStreamEnabled(!streamEnabled)}
          disabled={!streamEnabled}
        />
        <BarcodeScannerComponent
          onUpdate={(arg0, arg1) => {
            console.log(arg0, arg1);
            if (arg1) {
              const res = parse(arg1);
              // if (typeof res === "boolean" && res === false) return;

              setContent(res);
              setStreamEnabled(false);
            }
          }}
          videoConstraints={{}}
          height={500}
          width={500}
          facingMode="environment"
          // onError={(e) => console.error(e)}
          stopStream={!streamEnabled}
        />
        <div>Content: {JSON.stringify(content)}</div>
      </Card>
    </FlexContainer>
  );
};
